import { render, staticRenderFns } from "./DoctorCalendar.vue?vue&type=template&id=22289b18&scoped=true&"
import script from "./DoctorCalendar.vue?vue&type=script&lang=js&"
export * from "./DoctorCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22289b18",
  null
  
)

export default component.exports